import { getPublicFileSrcById } from "src/app/support/public-file";

export function getTenantLogoUrl(logo: string | undefined): string {
  return <string>getPublicFileSrcById(logo, { useFallback: true });
}
